import React from 'react';

const Appointment = () => (
  <>
    <div className="divider" id="marcar">
      <span><span className="dot"></span> 09 / Consulta</span>
      <span>Marque agora</span>
    </div>

    <section className="cta-section">
      <div className="cta-inner">
        <div className="eyebrow" style={{ opacity: .7 }}>Marque uma consulta</div>
        <h2 className="cta-title">
          Vamos colocar seu sorriso em <em>destaque</em>?
        </h2>

        <div className="cta-actions">
          <a
            href="https://wa.me/5521978982711"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary-new"
          >
            <span>Chamar no WhatsApp</span>
            <span className="arrow">↗</span>
          </a>
          <a
            href="tel:+5521978982711"
            className="btn-outline-new"
          >
            <span>Ligar agora</span>
            <span className="arrow">↗</span>
          </a>
        </div>
      </div>
    </section>
  </>
);

export default Appointment;
